import React from 'react'
import SkillBar from 'react-skillbars';
import './skill.css'
import ps from './img/ps.png'
import linux from './img/linux.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

AOS.init();

// You can also pass an optional settings object
// below listed default settings
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 200, // values from 0 to 3000, with step 50ms
  duration: 750, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});

function Skill() {
    const SKILLS = [
        {
          "type": "Python",
          "level": 90,
          "color": {
            "bar": "#FFCC33",
            "title": {
              "text": "#fff",
              "background": "#FFCC33"
            }
          }
        },
        {
          "type": "HTML5",
          "level": 80,
          "color": {
            "bar": "#FFCC33",
            "title": {
              "text": "#fff",
              "background": "#FFCC33"
            }
          }
        },
        {
          "type": "CSS",
          "level": 85,
          "color": {
            "bar": "#FFCC33",
            "title": {
              "text": "#fff",
              "background": "#FFCC33"
            }
          }
        },
        {
          "type": "javascript",
          "level": 75,
          "color": {
            "bar": "#A6CFE3",
            "title": {
              "text": "#fff",
              "background": "#A6CFE3"
            }
          }
        },
        {
          "type": "C",
          "level": 65,
          "color": {
            "bar": "#A6CFE3",
            "title": {
              "text": "#fff",
              "background": "#A6CFE3"
            }
          }
        },
        {
          "type": "C++",
          "level": 55,
          "color": {
            "bar": "#F3B0FF",
            "title": {
              "text": "#111",
              "background": "#F3B0FF"
            }
          }
        }
    ]
    const SKILLS2 = [
        {
          "type": "React",
          "level": 85,
          "color": {
            "bar": "#FFCC33",
            "title": {
              "text": "#fff",
              "background": "#FFCC33"
            }
          }
        },
        {
          "type": "Django",
          "level": 70,
          "color": {
            "bar": "#FFCC33",
            "title": {
              "text": "#fff",
              "background": "#FFCC33"
            }
          }
        },
        {
          "type": "ML & Ai",
          "level": 65,
          "color": {
            "bar": "#FFCC33",
            "title": {
              "text": "#fff",
              "background": "#FFCC33"
            }
          }
        },
        {
          "type": "nodejs",
          "level": 45,
          "color": {
            "bar": "#F3B0FF",
            "title": {
              "text": "#111",
              "background": "#F3B0FF"
            }
          }
        }
    ]
    return (
        <div className = 'skill_bar'>
            <h1 className = 'skill_bar_h1' data-aos="zoom-in" data-aos-delay="200" data-aos-duration="1500">My Skills</h1>
            <div className = 'skill_set'>
                <div className = 'skill_prog'>
                    <SkillBar skills={SKILLS}/>
                </div>
                <div className = 'skill_dev'>
                    <SkillBar skills={SKILLS2}/>
                </div>
            </div>
            <div className = 'skill_lists'>
            <h2  data-aos="fade-right" data-aos-delay="200" data-aos-duration="1500" align='center'><i><span role="img" aria-label="skill">💻⚙</span> Tech Stack <span role="img" aria-label="react">⚛️</span> (My Skillset) <span role="img" aria-label="skill">👋</span></i></h2>
            <div className = 'skill_list'>
              <div className = 'prog_set set1'>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://cdn.iconscout.com/icon/free/png-512/node-js-1-1174935.png' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur"  src = 'https://user-images.githubusercontent.com/68724228/119315331-5cea3780-bc93-11eb-9bbf-bc2c9f083e00.png' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur"  src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/1200px-Scikit_learn_logo_small.svg.png' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur"  src = 'https://icon-library.com/images/django-icon/django-icon-0.jpg' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur"  src = 'https://user-images.githubusercontent.com/68724228/119316381-85266600-bc94-11eb-97ed-3dafb4eb7a43.png' alt = 'prog'/></div> 
              </div>
              <div className = 'prog_set set2'>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Tensorflow_logo.svg/1200px-Tensorflow_logo.svg.png' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://1000logos.net/wp-content/uploads/2020/09/JavaScript-Logo.png' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = {linux} alt = 'prog'/></div>
                <div className = 'skill_list_prog firebase-logo'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://4.bp.blogspot.com/-rtNRVM3aIvI/XJX_U07Z-II/AAAAAAAAJXY/YpdOo490FTgdKOxM4qDG-2-EzcNFAWkKACK4BGAYYCw/s1600/logo%2Bfirebase%2Bicon.png' alt = 'prog'/></div>
              </div>
              <div className = 'prog_set set3'>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://image.flaticon.com/icons/png/512/732/732212.png' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://raw.githubusercontent.com/devicons/devicon/0d6c64dbbf311879f7d563bfc3ccf559f9ed111c/icons/css3/css3-original-wordmark.svg' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://cdn.worldvectorlogo.com/logos/npm.svg' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://www.pngkey.com/png/full/80-804196_vs-code-to-autocomplete-javascript-class-this-properties.png' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = 'https://cdn.worldvectorlogo.com/logos/material-ui-1.svg' alt = 'prog'/></div>
                <div className = 'skill_list_prog'><LazyLoadImage className = 'lazy_img' effect="blur" src = {ps} alt = 'prog'/></div>
              </div>
            </div>
            </div>
        </div>
    )
}

export default Skill
